import type { AuditOptions, AuditQuery, AuditResult } from '@obras/shared';
import { useQuery } from '@tanstack/react-query';

import { api, queryString } from '../../lib/api.js';

const csv = (values: readonly string[] | undefined): string | undefined =>
  values && values.length > 0 ? values.join(',') : undefined;

export function auditQueryString(filters: Partial<AuditQuery>): string {
  return queryString({
    page: filters.page ?? 1,
    perPage: filters.perPage ?? 50,
    from: filters.from,
    to: filters.to,
    userIds: csv(filters.userIds),
    actions: csv(filters.actions),
    entityType: filters.entityType,
    search: filters.search,
  });
}

export function useAudit(filters: Partial<AuditQuery>) {
  return useQuery({
    queryKey: ['auditoria', filters],
    queryFn: ({ signal }) => api.get<AuditResult>(`/auditoria${auditQueryString(filters)}`, signal),
    placeholderData: (previous) => previous,
  });
}

/** As opções saem do que existe na trilha, não de uma lista fixa. */
export function useAuditOptions() {
  return useQuery({
    queryKey: ['auditoria', 'opcoes'],
    queryFn: ({ signal }) => api.get<AuditOptions>('/auditoria/opcoes', signal),
    staleTime: 5 * 60 * 1000,
  });
}
